export default function omitKeys<T extends Record<string, any>>(
  value: T | null | undefined,
  keys: string[],
): T | null | undefined {
  if (!value) {
    return value;
  }
  const result: Record<string, any> = {};
  Object.keys(value).forEach((key) => {
    if (!keys.includes(key)) {
      result[key] = value[key];
    }
  });
  return result as T;
}
